export default __webpack_public_path__ + "static/media/deliver.8940dc77.svg";